// api/affiliations.js
import apiService from "../services/api";

export const affiliationsAPI = {
  // Получить список всех affiliations
  getAll: async () => {
    return await apiService.get(`/user/institutions/`);
  },

  // Получить affiliation по ID
  getById: async (id) => {
    return await apiService.get(`/user/institutions//${id}`);
  },

  // Создать новую affiliation (если нужно)
  create: async (data) => {
    return await apiService.post("/user/institutions/", data);
  },
};
